import React, { createContext, useContext } from 'react'
import { TableNameOptions } from '@landscape/ui-redux'

import column from './interface'
import { IAction } from './TableReducer'

interface TableProviderProps {
  initialState: ITableContext
  children: React.ReactNode
}

interface ITableContext {
  data: {
    [key: string]: number | string | boolean
  }[]
  dispatch: React.Dispatch<IAction>
  defaultSortAsc: boolean
  uniqueKeyColumn: string
  enableMultiSort?: boolean
  selectedColumn?: column
  sortColumn?: string
  sortDirection: 'asc' | 'desc' | 'none'
  sortMultiColumns?: string[]
  sortMultiDirections?: ('asc' | 'desc' | 'none')[]
  pagination?: boolean
  paginationRowsPerPageOptions?: number[]
  reduxTableName?: TableNameOptions
}

const TableContext = createContext({} as ITableContext)
export const useTableContext = () => useContext(TableContext)

export const TableProvider: React.FC<TableProviderProps> = ({ initialState, children }) => {
  return <TableContext.Provider value={initialState}>{children}</TableContext.Provider>
}
